import { useExecuteCommandMutation } from '@redux/api'

import { getCommandRequestData } from '@helpers'
import { ACTION_CODE, EVENT_CODE } from '@constants'
import { ActionRow } from '@types'

const useModifyDataAfterLoad = () => {
  const [executeCommand] = useExecuteCommandMutation()

  const modifyData = async (actionsObject: Record<EVENT_CODE, ActionRow>, data: any) => {
    const action = actionsObject[EVENT_CODE.AFTER_LOAD_DATA]
    if (action?.actionCode === ACTION_CODE.MODIFY_DATA && action.jsValue) {
      if (action.command) {
        const command = action.command
        const parameters = command?.parameters
          ? getCommandRequestData(command.parameters, data)
          : undefined

        const commandProps = {
          params: parameters,
          objectCode: command?.objectCode as string,
          commandCode: command?.name as string,
          body:
            command?.body && command?.httpMethod !== 'GET'
              ? getCommandRequestData(command.body, data)
              : undefined,
          method: command?.httpMethod as string,
        }

        const commandData = await executeCommand(commandProps)

        return new Function('srcObj', action.jsValue)({ data, commandData })
      } else {
        return new Function('srcObj', action.jsValue)({ data })
      }
    } else {
      return Promise.resolve(data)
    }
  }

  return {
    modifyData,
  }
}

export default useModifyDataAfterLoad
